export default function Footer() {
  return (
    <footer className="bg-white border-t border-gray-200 relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-12 pt-16 pb-12">
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          {/* Left: Brand */}
          <div>
            <h3 className="text-2xl font-bold text-[#1A1F36] mb-3">Praxia</h3>
            <p className="text-base text-gray-600 mb-4 font-medium">Learn. Earn. Progress.</p>
            <p className="text-sm text-gray-500">© 2024 Praxia. All rights reserved.</p>
          </div>

          {/* Middle: Product Links */}
          <div>
            <h4 className="text-base font-semibold text-[#1A1F36] mb-4">Product</h4>
            <ul className="space-y-3">
              <li>
                <a href="#about" className="text-sm text-gray-600 hover:text-[#7C4DFF] transition-colors cursor-pointer">
                  About Praxia
                </a>
              </li>
              <li>
                <a href="#microskills" className="text-sm text-gray-600 hover:text-[#7C4DFF] transition-colors cursor-pointer">
                  MicroSkills
                </a>
              </li>
              <li>
                <a href="#badges" className="text-sm text-gray-600 hover:text-[#7C4DFF] transition-colors cursor-pointer">
                  Badges & Microcredentials
                </a>
              </li>
              <li>
                <a href="#pathways" className="text-sm text-gray-600 hover:text-[#7C4DFF] transition-colors cursor-pointer">
                  Merit Pathways
                </a>
              </li>
              <li>
                <a href="#ai-tutor" className="text-sm text-gray-600 hover:text-[#7C4DFF] transition-colors cursor-pointer">
                  AI Tutor
                </a>
              </li>
            </ul>
          </div>

          {/* Right: Company Links */}
          <div>
            <h4 className="text-base font-semibold text-[#1A1F36] mb-4">Company</h4>
            <ul className="space-y-3">
              <li>
                <a href="#contact" className="text-sm text-gray-600 hover:text-[#7C4DFF] transition-colors cursor-pointer">
                  Contact
                </a>
              </li>
              <li>
                <a href="#privacy" className="text-sm text-gray-600 hover:text-[#7C4DFF] transition-colors cursor-pointer">
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="#terms" className="text-sm text-gray-600 hover:text-[#7C4DFF] transition-colors cursor-pointer">
                  Terms of Use
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom section */}
        <div className="pt-8 border-t border-gray-200 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-gray-500">Empowering learners worldwide</p>
          <a
            href="https://readdy.ai/?origin=logo"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-gray-500 hover:text-[#7C4DFF] transition-colors cursor-pointer"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
